import styled from 'styled-components';

const FooterContainer = styled.div`
  margin-top: 20px;
  text-align: center;
  color: whitesmoke;
`;

export default FooterContainer;
